// @flow
import { toastr } from "react-redux-toastr";
import { makeApiCall } from "../../../../services/apiService/apiService";

export const ticketingSuggestionModalActions = {
  GET_GROUP_SUGGESTION: "GET_GROUP_SUGGESTION",
  GET_BU_TYPES_FOR_GROUP_SUGGESTION: "GET_BU_TYPES_FOR_GROUP_SUGGESTION",
  GET_TICKET_TYPES_FOR_GROUP_SUGGESTION:
    "GET_TICKET_TYPES_FOR_GROUP_SUGGESTION",
  GET_TICKET_TYPE_DTO_FOR_GROUP_SUGGESTION:
    "GET_TICKET_TYPE_DTO_FOR_GROUP_SUGGESTION"
};

export const getGroupSuggestionAction = (data: boolean) => ({
  type: ticketingSuggestionModalActions.GET_GROUP_SUGGESTION,
  payload: data
});

export const getBuTypesAction = (data: boolean) => ({
  type: ticketingSuggestionModalActions.GET_BU_TYPES_FOR_GROUP_SUGGESTION,
  payload: data
});

export const getAllTicketTypesAction = (data: boolean) => ({
  type: ticketingSuggestionModalActions.GET_TICKET_TYPES_FOR_GROUP_SUGGESTION,
  payload: data
});

export const getTicketTypeDTOAction = (data: boolean) => ({
  type:
    ticketingSuggestionModalActions.GET_TICKET_TYPE_DTO_FOR_GROUP_SUGGESTION,
  payload: data
});

const getGroupSuggestionDefaultAction = () => (dispatch: Function) => {
  dispatch(
    getGroupSuggestionAction({
      isLoading: false,
      isLoaded: true,
      data: null
    })
  );
};

const getQueryParams = (ticketTypeId, entityInput, clientCode) => {
  const params = [{ key: "ticketTypeId", val: ticketTypeId }];
  if (entityInput) {
    params.push({
      key: "entityInput",
      val: entityInput
    });
  }
  if (clientCode) {
    params.push({
      key: "clientCode",
      val: clientCode
    });
  }
  return params;
};

export const getGroupSuggestion = (ticketTypeId, entityInput, clientCode) => (
  dispatch: Function
) => {
  dispatch(
    getGroupSuggestionAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getGroupSuggestion",
    replaceParamsArr: getQueryParams(ticketTypeId, entityInput, clientCode),
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched group suggestions ", res);
      if (res.status === "SUCCESS") {
        const data = {
          isLoading: false,
          isLoaded: true,
          data: res.response
        };
        dispatch(getGroupSuggestionAction(data));
      } else if (res.status === "FAILURE") {
        dispatch(getGroupSuggestionDefaultAction());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in getting group suggestion, res= ", res);
      dispatch(getGroupSuggestionDefaultAction());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in getting group suggestion ", res);
      dispatch(getGroupSuggestionDefaultAction());
    }
  };
  makeApiCall(requestObj);
};

export const getBuTypes = () => (dispatch: Function) => {
  dispatch(
    getBuTypesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getBuTypes",
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched all Bu Types ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getBuTypesAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getBuTypesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching oa matrics, res= ", res);
      dispatch(
        getBuTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching oa matrics ", res);
      dispatch(
        getBuTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getAllTicketTypes = buId => (dispatch: Function) => {
  dispatch(
    getAllTicketTypesAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketTypes",
    pathVariables: [
      {
        key: "#buId",
        val: buId
      }
    ],
    successCb: res => {
      //	eslint-disable-next-line
      console.log("Fetched all Ticket Types for bu {}  {} ", buId, res);
      if (res.status === "SUCCESS") {
        dispatch(
          getAllTicketTypesAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getAllTicketTypesAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in fetching oa matrics, res= ", res);
      dispatch(
        getAllTicketTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in fetching oa matrics ", res);
      dispatch(
        getAllTicketTypesAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getTicketTypeDTO = ticketTypeId => (dispatch: Function) => {
  dispatch(
    getTicketTypeDTOAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log(" userInfo from create Ticket ", ticketTypeId);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketTypeDetail",
    replaceParamsArr: [{ key: "id", val: ticketTypeId }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Ticket Type Detail ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getTicketTypeDTOAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getTicketTypeDTOAction({
            isLoading: false,
            isLoaded: true,
            data: {}
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Failure in Ticket Type Detail, res= ", res);
      dispatch(
        getTicketTypeDTOAction({
          isLoading: false,
          isLoaded: true,
          data: {}
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(" Exception in Ticket Type Detail ", res);
      dispatch(
        getTicketTypeDTOAction({
          isLoading: false,
          isLoaded: true,
          data: {}
        })
      );
    }
  };
  makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/commons/ticketingSuggestionModal/ticketingSuggestionModalRedux/ticketingSuggestionModalActionCreator.js